import { render, staticRenderFns } from "./agence-gestion-reseaux-sociaux.vue?vue&type=template&id=f89d4b86&scoped=true&"
import script from "./agence-gestion-reseaux-sociaux.vue?vue&type=script&lang=js&"
export * from "./agence-gestion-reseaux-sociaux.vue?vue&type=script&lang=js&"
import style0 from "./agence-gestion-reseaux-sociaux.vue?vue&type=style&index=0&id=f89d4b86&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f89d4b86",
  null
  
)

/* custom blocks */
import block0 from "./agence-gestion-reseaux-sociaux.vue?vue&type=custom&index=0&blockType=router"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Header: require('/app/components/Header.vue').default,Button: require('/app/components/Button.vue').default,Scroll: require('/app/components/Scroll.vue').default,Arguments: require('/app/components/Arguments.vue').default,Arguments2: require('/app/components/Arguments2.vue').default,ListCheckRed: require('/app/components/ListCheckRed.vue').default,Price: require('/app/components/Price.vue').default,LittleFaq: require('/app/components/LittleFaq.vue').default,TalkWithExpert: require('/app/components/TalkWithExpert.vue').default,FooterV2: require('/app/components/FooterV2.vue').default,LazyCalendly: require('/app/components/LazyCalendly.vue').default})
